import { render, staticRenderFns } from "./SettleSetting.vue?vue&type=template&id=f4959514&scoped=true"
import script from "./SettleSetting.vue?vue&type=script&lang=js"
export * from "./SettleSetting.vue?vue&type=script&lang=js"
import style0 from "./SettleSetting.vue?vue&type=style&index=0&id=f4959514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4959514",
  null
  
)

export default component.exports